export const useObtainDomainFromUrl = (url: string) => {
  return new URL(url).hostname.replace('www.', '');
};
